import type { RouteLocationNormalized, RouteRecordRaw } from "vue-router";
import type { AbilitiesEvaluation } from "vue-simple-acl/types/acl";
import { useFeature } from "~/core/composables/useFeature";
import { BREADCRUMBS } from "~/core/constants/breadcrumbs";
import { ACLRoles } from "~/core/models/ACLRoles.enum";
import { AppFeatures } from "~/core/models/AppFeatures.enum";
import { canWithRedirection } from "~/core/utils/canWithRedirection";
import { PATH_FLEETS, PATH_FLEETS_UID } from "~/modules/fleet/constants";
import FleetPage from "~/modules/fleet/views/FleetPage.vue";
import FleetsPage from "~/modules/fleet/views/FleetsPage.vue";

const { isFeatureEnabled } = useFeature();

const routes: RouteRecordRaw[] = [
  {
    path: PATH_FLEETS,
    component: FleetsPage,
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: AbilitiesEvaluation,
      ) => canWithRedirection(can, ACLRoles.CAN_READ_DEVICE),
      breadcrumb: BREADCRUMBS.FLEETS,
    },
  },
  {
    path: PATH_FLEETS_UID,
    component: FleetPage,
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: AbilitiesEvaluation,
      ) => canWithRedirection(can, ACLRoles.CAN_READ_DEVICE),
      breadcrumb: BREADCRUMBS.FLEETS,
    },
  },
];

export default routes;
